// extracted by mini-css-extract-plugin
export default {"wpsau":"WPSAU_wpsau__KGjEK","quote":"WPSAU_quote__LewDk","swiper_ctrl":"WPSAU_swiper_ctrl__dmvhU"};